<template>
  <section
    class="student-credentials-reset"
    :style="{
      'background-image': 'url(' + bucketUrl + '/assets/background_student.png)'
    }"
  >
    <header-logged-out type="student" :checkuser="false" />
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-flex cols="12" sm="10" md="8" lg="6" xl="4">
          <v-card>
            <form @submit.prevent="submit">
              <v-toolbar dark color="primary" flat>
                <v-toolbar-title>
                  Student Username or Email Reset
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <transition name="fade-transition" mode="out-in">
                <v-card-text v-if="!credential" key="classcode">
                  <p>Enter one of your class codes</p>
                  <class-code
                    title="Class code"
                    v-model="classCode"
                    v-validate="'required|min:4'"
                    data-vv-name="class_code"
                    data-vv-as="class code"
                    hint="The class code must be supplied to you by a teacher"
                    data-vv-validate-on="change"
                    :error-messages="errors.collect('class_code')"
                  />
                </v-card-text>
                <v-card-text v-else key="credentials">
                  <p class="text-center result-creds">
                    Your username or email is <strong>{{ credential }}</strong>
                  </p>
                </v-card-text>
              </transition>
              <v-card-actions class="px-3 pb-3 pt-0">
                <div>
                  <router-link to="/student/login" style="color: #1565c0">
                    Back to login.
                  </router-link>
                </div>
                <v-spacer />
                <v-btn
                  v-if="!credential"
                  color="primary"
                  type="submit"
                  :loading="loading"
                  :disabled="loading"
                >
                  Check Code
                </v-btn>
              </v-card-actions>
            </form>
          </v-card>
          <custom-snackbar />
        </v-flex>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Student from '../models/Student'
import ClassCode from '@/components/ClassCode'
import { mapMutations, mapState } from 'vuex'
import CustomSnackbar from '@/components/snackbar/snackbar'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'

export default {
  name: 'ForgotCredentials',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    ClassCode,
    CustomSnackbar,
    HeaderLoggedOut
  },
  data() {
    return {
      classCode: '',
      visible: false,
      credential: null,
      loading: false
    }
  },
  computed: {
    ...mapState(['bucketUrl'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return
      }

      try {
        let payload = {
          invitation_code: this.classCode
        }
        this.loading = true

        const student = await Student.dispatch('resetUsername', {
          payload: payload
        })
        this.credential = student.email

        this.loading = false
        this.showSnackbar('Username found')
      } catch (error) {
        //console.log(error)
        this.showErrorSnackbar('Class Code not found')
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.student-credentials-reset {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .result-creds {
    font-size: 18px;
    strong {
      font-size: 20px;
    }
  }
}
</style>
